<template>
  <div>
    <el-row>
      <el-col :span="11">
        <el-row>
          <el-select>
            <el-option label="进料过磅" value="1"></el-option>
          </el-select>
        </el-row>
        <el-row>
          <div class="number">8088</div>
        </el-row>
        <el-row>
          <el-button>按钮1</el-button>
          <el-button>按钮1</el-button>
          <el-button>按钮1</el-button>
          <el-button>按钮1</el-button>
        </el-row>
        <el-row>
          <el-col :span="5"><h3>过磅信息</h3></el-col>
          <el-col :span="5" :offset="14">展开详情 ></el-col>
        </el-row>
        <el-row>
          <el-form label-width="100px">
            <!-- 从这里开始复制 -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="过磅单号">
                  <el-input></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车牌号">
                  <el-input></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 从这里结束 -->
          </el-form>
        </el-row>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-row>
          <el-col :span="12" v-for="i in 4" :key="i">
            <el-image
              style="width: 100px; height: 100px"
              src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
              :fit="cover"
            ></el-image>
          </el-col>
        </el-row>

       
          <el-row>
            <el-form :inline="true">
              <el-form-item label="车号">
                <el-input></el-input>
              </el-form-item>
              <el-form-item label="车号">
                <el-input></el-input>
              </el-form-item>
              <el-form-item label="车号">
                <el-input></el-input>
              </el-form-item>
              <el-button>查询</el-button>
            </el-form>
          </el-row>
          <el-row  class="overflow-auto">
            <el-col :span="11" v-for="i in 20" :key="i" class="rigth-card">
              <el-card>
                <el-form label-width="60px">
                  <el-row>
                    <el-form-item label="车牌"></el-form-item>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="物资">
                        <el-input></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="仓库">
                        <el-input></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row type="flex" justify="space-between">
                    <div style="width: 100%; text-align: center">
                      <div>毛重</div>
                      <div>8088</div>
                    </div>
                    <div style="width: 100%; text-align: center">
                      <div>毛重</div>
                      <div>8088</div>
                    </div>
                    <div style="width: 100%; text-align: center">
                      <div>毛重</div>
                      <div>8088</div>
                    </div>
                  </el-row>
                  <el-form-item label="仓库">
                    <el-input></el-input>
                  </el-form-item>
                  <el-form-item label="仓库">
                    <el-input></el-input>
                  </el-form-item>
                  <el-form-item label="仓库">
                    <el-input></el-input>
                  </el-form-item>
                  <el-row type="flex" justify="space-between">
                    <el-button>按钮1</el-button>
                    <el-button>按钮1</el-button>
                    <el-button>按钮1</el-button>
                    <el-button>按钮1</el-button>
                  </el-row>
                </el-form>
              </el-card>
            </el-col>
          </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "TestTwo",
};
</script>

<style scoped>
.flex-row {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-row.between {
  justify-content: space-between;
}
.flex-row.wrap {
  flex-wrap: wrap;
}

.number {
  height: 200px;
  width: 80%;
  line-height: 200px;
  text-align: center;
  font-size: 5rem;
  background: rgb(247, 244, 229);
  border: 2px solid rgb(191, 169, 46);
  margin: 20px auto;
}
.overflow-auto {
  height: 55vh;
  overflow-y: scroll;
}
.rigth-card {
  margin-top: 10px;
}
.rigth-card:nth-of-type(2n) {
  margin-left: 20px;
}
</style>
